


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Cloundbtn extends Vue {
  @Prop() thurl!: any;
  @Prop({ default: '171px' }) width!: string;
  @Prop({ default: '34px' }) height!: string;
  actspan: boolean = true;
  imgUrl = require('../assets/inxbtn.png');
  actspanFc() {
    this.actspan = false;
    setTimeout(() => {
      this.actspan = true;
    }, 1000);
  }
}
